<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增调研问卷
      </a-button>
      <a-select
        placeholder="请选择合作企业"
        v-model="company_id"
        style="
          width: 225px;
          margin: 19px 23px 0;
          float: right;
          border-radius: 15px;
        "
        @change="(value) => onChangecompany(value)"
      >
        <a-select-option
          v-for="item in companyData"
          :key="item.id"
          :value="item.id"
        >
          {{ item.companyInfo.qichacha_name }}
        </a-select-option>
      </a-select>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :row-key="(record) => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: (total) => `共${total}条`,
        }"
        @change="changePage"
      >
        <template slot="jump_url" slot-scope="text, record">
          <a @click="() => handleChange(record)">查看</a>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="() => editAndAdd(record)">编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.data.status === 1 ? '禁用' : '启用'"
            :alert-title="
              record.data.status === 1 ? '确定禁用？' : '确定启用？'
            "
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <question-modal
      :key="datekey"
      ref="formRef"
      :visible="visible"
      :title="title"
      :questionData="questionData"
      @onCancel="onCancel"
    >
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="onSubmit"
      />
    </question-modal>
    <details-modal
      :visible="visibleDetails"
      :src="detailUrl"
      @onCancel="onCancelDetail"
    >
      <form-button
        :show-msg="false"
        submit-text="确定"
        @onCancel="onCancelDetail"
        @onSubmit="onCancelDetail"
      />
    </details-modal>
  </div>
</template>
<script>
const uuidv1 = require("uuid/v1");
import { columns } from "./data/index";
import { getType, getCompany } from "./utils/dealTable";
import QuestionModal from "./modal/index.vue";
import DetailsModal from "./modal/detailsModal.vue";
export default {
  components: { QuestionModal, DetailsModal },
  data() {
    return {
      datekey: Date.now(),
      selectData: [],
      companyData: [],
      company_id: "",
      columns,
      tableData: [],
      pageSize: 10,

      current: 1,
      total: 0,
      loading: true,
      visible: false,
      title: "",
      templateId: undefined,
      btnIsLoading: false,
      visibleDetails: false,
      questionData: [],
      detailUrl: "",
    };
  },
  mounted() {
    // 获取合作企业
    this.getCompanyList();
    // 获取表格数据
    // 获取问题
  },
  methods: {
    // 获取问题
    async getQuestionData(params) {
      let result = await this.$http.post("/QuestionBank/getList", params);
      if (result.data.status === 1) {
        let data = result.data.data.data_list.filter(
          (item) => item.status === 1
        );
        this.questionData = data;
      }
    },
    onChangecompany(value) {
      this.datekey = Date.now();
      this.current = 1;
      this.company_id = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        cooperation_company_id: this.company_id,
      });
      this.getQuestionData({ cooperation_company_id: this.company_id });
    },
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post("/Company/getCooperationCompanyList");
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
        this.company_id = this.companyData[0].id;
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          cooperation_company_id: this.company_id,
        });
        this.getQuestionData({ cooperation_company_id: this.company_id });
      }
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post("/Questionnaire/getList", params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            product_info_title: item.product_info.title,
            name: item.name,
            aim: item.aim,
            scene: item.scene,
            jump_url: item.jump_url,
            data: item,
          };
          temp.push(obj);
        });
        this.tableData = temp;
      }
    },
    // 编辑或新增
    editAndAdd(record) {
      this.visible = true;
      this.companyid = this.company_id;
      if (!record.id) {
        // 新增
        this.title = "新增调研模板";

        this.templateId = "";
        this.$nextTick(() => {
          this.$refs.formRef.form.resetFields();
        });
      } else {
        // 编辑
        this.templateId = record.id;
        this.title = "编辑调研模板";
        this.$nextTick(() => {
          let data = {
            name: record.data.name,
            aim: record.data.aim,
            product_id: record.data.product_id,
            scene: record.data.scene,
            company_id: record.data.company_id,
            question_ids: record.data.link_question_list.map(
              (item) => item.question_id
            ),
          };
          this.$refs.formRef.form.setFieldsValue(data);
        });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.form.validateFields(async (err, values) => {
        console.log("TCL: onSubmit -> values", values);
        if (!err) {
          let data = {
            name: values.name,
            aim: values.aim,
            scene: values.scene,
            product_id: values.product_id,
            question_ids: values.question_ids.join(),
          };
          this.btnIsLoading = true;
          let result = await this.$http.post("/Questionnaire/update", {
            ...data,
            id: this.templateId,
            cooperation_company_id: this.company_id,
          });
          this.btnIsLoading = false;
          if (result.data.status === 1) {
            this.$message.success("操作成功！");
            this.visible = false;
            this.getTableData({
              page: this.curren,
              pageSize: this.pageSize,
              cooperation_company_id: this.company_id,
            });
          }
        }
      });
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result = await this.$http.post("/Questionnaire/setStatus", {
        id: record.id,
        status: record.status === 1 ? 0 : 1,
      });
      if (result.data.status === 1) {
        this.$message.success("操作成功！");
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          cooperation_company_id: this.company_id,
        });
      }
    },
    // 删除
    async onDelete(record) {
      let result = await this.$http.post("/Questionnaire/setStatus", {
        id: record.id,
        status: -1,
      });
      if (result.data.status === 1) {
        this.$message.success("操作成功！");
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          cooperation_company_id: this.company_id,
        });
      }
    },
    // 查看
    handleChange(record) {
      console.log("handleChange -> record", record);
      this.detailUrl = record.jump_url;
      this.visibleDetails = true;
    },
    // 取消查看
    onCancelDetail() {
      this.visibleDetails = false;
    },
    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.getTableData({
        page: pagination.current,
        pageSize: pagination.pageSize,
        cooperation_company_id: this.company_id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
/deep/.ant-select-selection--single {
  border-radius: 15px;
}
</style>
